import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminRoutingModule } from './admin-routing.module';
import { AdminComponent } from './admin/admin.component';
import { FormsModule } from '@angular/forms';
import { DxButtonModule, DxDataGridModule, DxDateBoxModule, DxDropDownBoxModule, DxListModule, DxLoadIndicatorModule, DxLoadPanelModule, DxPopoverModule, DxSelectBoxModule, DxTemplateModule, DxTextBoxModule, DxToastModule, DxToolbarModule, DxValidatorModule } from 'devextreme-angular';
import { SystemAdminComponent } from './system-admin/system-admin.component';
import { SharedModule } from '@shared/shared.module';
import { AuditLogsComponent } from './audit-logs/audit-logs.component';
import { ActivityTackerComponent } from './audit-logs/activity-tacker/activity-tacker.component';
import { PsrPublishHistoryComponent } from './audit-logs/psr-publish-history/psr-publish-history.component';
import { ManageReleaseDateComponent } from './manage-release-date/manage-release-date.component';
import { ManageUsersComponent } from './admin/manage-users/manage-users.component';
import { PsrpsrGroupManageUserComponent } from './admin/psr-group-manage-users/psr-group-manage-user.component';
import { ManageProjectsComponent } from './manage-projects/manage-projects.component';
import { ManagePublishDistComponent } from './manage-publish-dist/manage-publish-dist.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ManageProductionEntityComponent } from './manage-production-entity/manage-production-entity.component';
import { PicklistAdminComponent } from './picklist-admin/picklist-admin.component';
import { ChangePriorTrackerComponent } from './audit-logs/change-prior-tracker/change-prior-tracker.component';


@NgModule({
  declarations: [
    AdminComponent,
    SystemAdminComponent,
    AuditLogsComponent,
    ActivityTackerComponent,
    PsrPublishHistoryComponent,
    ManageReleaseDateComponent,
    ManageUsersComponent,
    PsrpsrGroupManageUserComponent,
    ManageProjectsComponent,
    ManagePublishDistComponent,
    ManageProductionEntityComponent,
    PicklistAdminComponent,
    ChangePriorTrackerComponent
  ],
  imports: [
    AutoCompleteModule,
    CommonModule,
    SharedModule,
    AdminRoutingModule,
    DxTextBoxModule,  
    DxDateBoxModule,
    DxButtonModule,
    DxSelectBoxModule,
    DxDataGridModule,
    DxPopoverModule,
    DxListModule,
    DxToolbarModule,
    DxTemplateModule,
    FormsModule,
    DxValidatorModule,
    DxToastModule,
    DxLoadPanelModule,
    DxDropDownBoxModule,
    DxLoadIndicatorModule
  ]
})
export class AdminModule { }
